import { render, staticRenderFns } from "./MapSectionRestaurant.vue?vue&type=template&id=00a86734&scoped=true&"
import script from "./MapSectionRestaurant.vue?vue&type=script&lang=js&"
export * from "./MapSectionRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a86734",
  null
  
)

export default component.exports